import { Table as TableIcon, GridFill, ListUl } from "react-bootstrap-icons";
import useT from "../../i18n/useT";

// Table / grid / list switch. On mobile the table option is hidden (only grid/list).
const ViewToggle = ({ view, setView, isMobile }) => {
    const t = useT();
    return (
        <div className="view-toggle" role="group" aria-label="View mode">
            {!isMobile && (
                <button type="button" className={view === "table" ? "active" : ""} onClick={() => setView("table")} title={t("view.table")} aria-label={t("view.table")}>
                    <TableIcon />
                </button>
            )}
            <button type="button" className={view === "grid" ? "active" : ""} onClick={() => setView("grid")} title={t("view.grid")} aria-label={t("view.grid")}>
                <GridFill />
            </button>
            <button type="button" className={view === "list" ? "active" : ""} onClick={() => setView("list")} title={t("view.list")} aria-label={t("view.list")}>
                <ListUl />
            </button>
        </div>
    );
};

export default ViewToggle;
